import { api } from './apiClient';

export const fetchFeedbackList = async (page = 1, limit = 10, search = '', filters = {}, startDate = '', endDate = '') => {
  try {
    const requestBody = {
      page,
      limit,
      searchtext: search,
      filters: { ...filters },
    };

    // Add date filters at top level if provided (similar to users API)
    if (startDate && endDate) {
      // Format dates to include time (start of day and end of day)
      const startDateTime = `${startDate}T00:00:00.000Z`;
      const endDateTime = `${endDate}T23:59:59.999Z`;
      
      requestBody.startDate = startDate;
      requestBody.endDate = endDate;
      // Also add with time for APIs that need full datetime
      requestBody.startDateTime = startDateTime;
      requestBody.endDateTime = endDateTime;
      
      // Also add to filters object with multiple possible field names
      requestBody.filters.startDate = startDate;
      requestBody.filters.endDate = endDate;
      requestBody.filters.startDateTime = startDateTime;
      requestBody.filters.endDateTime = endDateTime;
      // Some APIs might expect createdAt range
      requestBody.filters.createdAtStart = startDate;
      requestBody.filters.createdAtEnd = endDate;
      requestBody.filters.createdAtStartTime = startDateTime;
      requestBody.filters.createdAtEndTime = endDateTime;
      requestBody.filters.dateStart = startDate;
      requestBody.filters.dateEnd = endDate;
    }

    const response = await api.post('/api/v1/admin/feedback/list', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const deleteFeedback = async (feedbackId) => {
  try {
    const response = await api.delete(`/api/v1/admin/feedback/${feedbackId}`);
    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

